import React from "react";
import { reviewsWidgetId } from "utils/constants";
import useOkendo from "hooks/useOkendo";

const OkendoReviewsWidget = ({ data, productId }) => {

	const { product, groupId } = data;
	const widgetContainer = useOkendo();

	const productReviewId = productId || product?.id;

	return (
		<div
			id={reviewsWidgetId}
			className="overflow-hidden"
			ref={widgetContainer}
			data-oke-widget
			{...(productReviewId && { "data-oke-reviews-product-id": `shopify-${productReviewId}` })}
			{...(groupId && { "data-oke-reviews-group-id": groupId })}
		></div>
	);
};

export default OkendoReviewsWidget;